import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Seo from "../components/Seo";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function Compteur() {
  const rows = []; // Alimenté uniquement par des captures d'analytics datées, côté serveur.

  return (
    <div>
      <Seo routeKey="/pilote" path="/compteur" title="Le compteur — chiffres en public | VIRALYA" description="Les chiffres hebdomadaires de nos personnages, publiés avec captures d'analytics datées." />
      <Header />
      <main className="page">
        <div className="container page-narrow">
          <Link to="/" className="back-link"><ArrowLeft size={15} /> Accueil</Link>
          <span className="eyebrow"><span className="sq" />Le compteur</span>
          <h1 className="h2" style={{ marginBottom: "0.5rem" }}>Nos chiffres, en public, chaque semaine</h1>
          <p className="lead" style={{ marginBottom: "1.5rem" }}>
            Aucun chiffre n'est affiché sans capture d'analytics native datée. Un chiffre non prouvable est retiré, jamais arrondi. Les mauvaises semaines sont publiées comme les bonnes.
          </p>
          {rows.length === 0 ? (
            <div className="glass card center" data-testid="compteur-empty">
              <p className="muted">Aucune donnée publiée pour l'instant. La première mesure de nos personnages est prévue le lundi 12 octobre 2026.</p>
            </div>
          ) : (
            <div className="glass" style={{ overflowX: "auto" }}>
              <table className="data-table" data-testid="compteur-table">
                <thead><tr><th>Semaine</th><th>Personnage</th><th>Plateforme</th><th>Mesure</th><th>Preuve</th></tr></thead>
                <tbody>{rows.map((r, i) => <tr key={i}><td>{r.semaine}</td><td>{r.personnage}</td><td>{r.plateforme}</td><td className="tnum">{r.mesure}</td><td><a href={r.proof_url} target="_blank" rel="noreferrer">capture</a></td></tr>)}</tbody>
              </table>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
